<template>
	<div class="page-leader">
        <div class="page-leader__header">
            <div class="container">
                <div class="leader-header" ref="propertiesHeader">
					<div class="leader-header__container">
						<div class="leader-header__breadcrumb">
							<div class="leader-header__breadcrumb-wrap" ref="breadcrumbs">
								<a class="breadcrumbs__link" @click="goBack()">
									<SvgIcon class="breadcrumbs__icon" iconName="ico-arrow-left"/>
								</a>
								<span class="section-title section-title--breadcrumbs">{{ customerName }}</span>
								<span class="leader-header-popup-icon"
									@click="showNote"
									@mouseover="showNote"
									@mouseleave="hideNote"
									ref="exclamation-mark"
								>
										<SvgIcon class="leader-header_icon" iconName="ico-exclamation-mark"/>
										<PartNote :data="DataNote"/>
								</span>
							</div>
							<span class="leader-header__breadcrumb-count" v-if="counter > 1">{{ counter }} matches</span>
							<span class="leader-header__breadcrumb-count" v-else-if="counter === 1">{{ counter }} match</span>
						</div>
						<div class="leader-header__button">
							<div class="leader-header__match">
								<a @click="popupToggle" :id="matchPropertyId" class="btn btn--white leader-header__match-btn">
									<span>{{ matchPropertyLabel }}</span>
								</a>
							</div>
							<router-link class="btn btn--sm btn--white" :to="{ name: goInDashboard() ? 'EditCustomerAdmin' : 'EditCustomerAgent', params: { id: $route.params.id } }">
								<SvgIcon class="leader-header__button-icon" iconName="ico-edit"/>
								Edit
							</router-link>
							<a class="btn leader-header__button-arhive" @click="archiveCustomer">
								<SvgIcon class="leader-header__button-icon" iconName="ico-arhive"/>
								Archive
							</a>
						</div>
					</div>
					<div class="leader-header__critical-note" v-if="customerInfo.critical_note">
						<span>{{customerInfo.critical_note}}</span>
					</div>
					<div class="leader-header__filters">
						<ul class="leader-header__filters-list">
							<li class="leader-header__filters-item" v-for="(group, index) in filters" :key="index">
								<span class="leader-header__filters-item-title"  @mouseover="infoPopup = true" @mouseleave="infoPopup = false">{{group.name}}
									<span class="leader-header__filters-item-popup-wrap">
										<SvgIcon class="leader-header__filters-item-info" v-if="(group.name === ' Building Size' && altered_building_size) || (group.name === 'Lot Size' && altered_lot_size)" iconName="ico-exclamation-mark"/>
										<div class="leader-header__filters-item-popup">
											<span>
												The values have been automatically changed by the system, <br/> min -10% and max +20%!
											</span>
										</div>
									</span>
								:</span>
								<div class="leader-header__filters-item-pill" v-for="pill in group.labels" :key="pill.id" :class="{ 'leader-header__filters-item-pill--disable': !pill.show }" @click="deactivateFilterPill(group.key, pill)">
									<span class="leader-header__filters-item-pill-name">{{pill.value}}</span>
									<span>
										<SvgIcon class="delete-item-icon" iconName="ico-close-sm"/>
									</span>
								</div>
								<span @click="disableAllPills(group)" v-if="group.labels.length > 1">
									<SvgIcon class="delete-item-icon-all" iconName="ico-close-sm"/>
								</span>
							</li>
						</ul>
					</div>
				</div>
            </div>
        </div>
		<div class="container">
		<!-- ovde treba da ide  -->
			<div class="page-leader__header-matching-properties">
				<span class="section-title section-title--sm section-title--matching-properties">Matching Properties</span>
				<div class="notification-wrap-center">
					<PartNotifications :data="notificationsData" v-if="notificationsData.msg"/>
				</div>
				<div :class="{ 'select-stage': true, 'select-stage--disabled': !customPropertiesChangeStage.length > 0 }">
					<label>
						Change Stage:
					</label>
					<div class="select-stage__select-wrap">
						<div :class="{ 'select-stage__select': true, 'active': isVisible }" @click="toggleVisibility">
							<span class="dropdown__holder" :class="{'dropdown__holder--first-selected': currentSelected.name === ''}" :style="{background: currentSelected.color + ' !important', color: '#fff'}">
								<span v-if="currentSelected.name === '' && allStages.length > 0">{{allStages[0].title}}</span>
								{{ currentSelected.name }}
							</span>
							<span><SvgIcon class="select-stage__select-icon" iconName="ico-angle-down"/></span>
						</div>
						<!-- Stages dropdown -->
						<div
						class="dropdown_stages"
						v-on-click-outside="onClickOutside"
						v-if="isVisible">
							<transition name="fade">
								<ul class="dropdown">
									<li class="color-picker__item" v-for="(item) in allStages" :key="item.id">
										<a class="dropdown__link">
											<span class="color-picker__item-color" :style="{background: item.color}"></span>
											<span class="color-picker__item-text" @click="changeStageMany({stageRowId: currentSelected.id, stageRow: currentSelected.name, stage_id: item.id, stage_name: item.title }, item.title, item.datepicker, item.color)">
												{{ item.title }}
											</span>
										</a>
									</li>
								</ul>
							</transition>
						</div >
					</div>
				</div>
				<!-- <span class="header-matching-properties__selected-items">{{ customPropertiesChangeStage.length }} of properties selected</span> -->
				<span class="header-matching-properties__selected-items" :class="{ 'show': customPropertiesChangeStage.length > 0 }">
					{{ getIsAllSelected ? total : customPropertiesChangeStage.length }} 
					{{ customPropertiesChangeStage.length === 1 ? 'property' : 'properties' }} selected
				</span>
			</div>

		</div>
		<div class="container">
			<div class="table__container table__container--matching-properties">
				<div class="table__item">
					<!-- Custom table accordion-custom-table -->
					<div class="accordion-custom-table">
						<div class="accordion-custom-table__item" ref="accordionArrow" :key="index">
							<ul class="accordion-custom-table__list-button">
								<li class="accordion-custom-table__inner-button" ref="iconAccordion">
									<a class="accordion-custom-table__button" @click="toggle">
										<div class="accordion-custom-table__button-name" :style="{background: data.buttonNameColor}">
											Lead
										</div>
										<span class="accordion-custom-table__button-num">
											{{ countLeadProperty > 1 ? countLeadProperty + ' Properties' : countLeadProperty + ' Property' }}
										</span>
										<span class="accordion-custom-table__button-icon">
											<SvgIcon class="accordion-custom-table__button-arrow" iconName="ico-arrow-down"/>
										</span>
									</a>
								</li>
							</ul>
							<slide-up-down :active="active" :duration="800">
								<div class="accordion-custom-table__content ">
									<BlockCustomTable
										class="matching-properties-table extended-table"
										ref="leadCustomers"
										:obj="dataTableIntro"
										@updateStage="updateStage"
										@sendEmailPopup="sendEmailPopup"
										@click="sortData($event, field.key)"
										@sortData="sortLeads"
										@loadMore="loadMore"
										@onSortLead="onSortLead"
										:sort="localOrderBy"
										:total="countLeadProperty"
										@updateActive="updateActive"
									/>
								</div>
							</slide-up-down>
						</div>
					</div>
				</div>
				<template v-if="Object.keys(this.allTables).length > 0">
					<div class="table__item" v-for="(table, index) in allTables" :key="index">
						<BlockAccordion
							class="extended-table"
							:data="table"
							:index="index"
							:flagCheckbox="true"
							:infinitScrollFlag="infinitScrollFlag"
							@setAgainTable="setAgainTable"
							@noLeadUpdate="noLeadUpdate"
							@dismissStage="dismissStage"
							@showPopupNote="showPopupNote"
							@onSort="onSort"
							:sort="localOrderBy"
							ref="stageTableRefs"
						/>
					</div>
				</template>
			</div>
		</div>
		<BlockPopupMatchCustomer
			class="block-match-customer__popup"
			v-if="showPopup"
			:data="DataMatchProperty"
			@closePopupCustomer="closePopupCustomer"
			@startFiltration="startFiltration"
			@loadMore="loadMore"
			:sort="localOrderBy"
			:parentType="parentType"
			@sendEmailPopup="sendEmailPopup"
		/>
		<BlockPopupDetails
			@closePopupForm="closePopupForm"
			@showPopupNote="showPopupNote"
			:class="{'activeNote' : activeNote}"
			class="popups-content"
			:data="NoteData"
		/>
		<PartPopupEmail
			ref="emailPopup"
			v-if="emailPopup"
			:data="DataPartPopupEmail"
			:isHistory="false"
			:propPDF="selectedPropertyPdfLink"
			@closePopupEmail="closePopupEmail"
			@sendingEmail="sendingEmail"
			@afterSendEmail="afterSendEmail"
		/>
		<PartLoaderBig v-if="preloader || infinitScrollFlag"/>

		<BlockFormPopup
			v-if="activePopup"
			:class="{'active' : activePopup}"
			:data="popupData"
			class="popups-content"
			@closePopupForm="closePopupFormFirst"
			@submitForm="submitForm"
		/>
	</div>
</template>

<script>
import { formatNumber } from '@/config/util';
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import PartNote from '@/components/parts/PartNote';
import BlockCustomTable from '@/components/blocks/BlockCustomTable';
import BlockAccordion from '@/components/blocks/BlockAccordion';
import BlockPopupMatchCustomer from '@/components/blocks/BlockPopupMatchCustomer';
import BlockPopupDetails from '@/components/blocks/BlockPopupDetails';
import PartPopupEmail from '@/components/parts/PartPopupEmail';
import SlideUpDown from 'vue-slide-up-down';
import PartNotifications from '@/components/parts/PartNotifications';
import PartLoaderBig from '@/components/parts/PartLoaderBig';
import { mixin as onClickOutside } from 'vue-on-click-outside';
import BlockFormPopup from '@/components/blocks/BlockFormPopup';

export default {
	props: {
		data: {
			type: Object,
			required: true
		},
		sort: {
			type: String,
			required: false
		}
	},
	data () {
		return {
			isVisible: false,
			preventGetPage: false,
			filtrationInProgress: false,
			// stages
			stagesData: {
				label: 'Change Stage:',
				placeholder: 'Add Agent',
				inputId: 'stage-select',
				labelId: 'stage-select-label',
				mandatoryFiled: false,
				options: [
					{ label: 'Option 1', value: 'option1' },
					{ label: 'Option 2', value: 'option2' },
					{ label: 'Option 3', value: 'option3' }
				]
			},
			preloader: false,
			active: false,
			index: '1',
			emailPopup: false,
			DataPartPopupEmail: {},
			customerName: '',
			showPopup: false,
			infoPopup: false,
			selectedPropertyPdfLink: '',
			altered_building_size: false,
			altered_lot_size: false,
			notificationsData: {
				type: '',
				msg: ''
			},
			activePopup: false,
			popupData: {
				popupId: 'popup_emailed',
				popupTitle: '',
				DataNoteArea: {
					label: 'Notes',
					inputId: 'note-popup-input',
					labelId: 'note-popup-label',
					classTextarea: 'small-area'
				},
				showCalendar: false,
				DataCalendar: {
					label: '',
					inputId: 'date_calendar-input',
					labelId: 'date_calendar-label',
					icon: true
				}
			},
			stageMany: [],
			// allTablesCount: [],
			isLoadingCustomStageMany: false,
			matchPropertyId: 'matchPropertyId',
			matchPropertyLabel: 'Match Property',
			DataMatchProperty: {
				popupTitle: 'Match Property',
				preloader: false,
				DataMatchCustomer: {
					customerEmail: false,
					stickyHeader: true,
					noCollapse: false,
					tableClass: 'text-nowrap',
					fields: [
						{ key: 'title', sortable: true, label: 'Name' },
						{ key: 'offering_type_label', label: 'Offering Type' },
						{ key: 'area_label', label: 'Area' },
						{ key: 'property_type_label', label: 'Type' },
						{ key: 'building_size', label: 'Building Size' },
						{ key: 'lot_size', label: 'Lot Size' },
						{ key: 'regular_price', label: 'Price' },
						{ key: 'price_buildable_sf', label: 'Price per Buildable SF' },
						{ key: 'price_psf', label: 'Price per SF' },
						{ key: 'lease_price', label: 'Lease Price' },
						{ key: 'yearly_price', label: 'Yearly Price' },
						{ key: 'listing_status_label', label: 'Listing Status' },
						{ key: 'listing_type_label', label: 'Listing Type' },
						{ key: 'date_listed', label: 'Date Listed' },
						{ key: 'updated_at', label: 'Date Updated' }
					],
					items: []
				},
				DataSearch: {
					label: '',
					placeholder: 'Search...',
					labelId: 'popup-property-search-label',
					inputId: 'popup-property-search-input'
				}
			},
			dataTableIntro: {
				customerEmail: false,
				noCollapse: false,
				// noLocalSorting: true,
				stageTable: true,
				checkboxes: false,
				stickyHeader: true,
				tableClass: 'text-nowrap',
				sortable: true,
				fields: [
					{ key: 'title', sortable: true, label: 'Property', sortOrder: 'asc' },
					{ key: 'stage', sortable: true, label: 'Stage' },
					// { key: 'source', label: 'Source' },
					{ key: 'area_label', sortable: true, label: 'Area' },
					{ key: 'property_type_label', sortable: true, label: 'Property Type' },
					{ key: 'regular_price', sortable: true, label: 'Price' },
					{ key: 'price_buildable_sf', sortable: true, label: 'Price per Buildable SF' },
					{ key: 'price_psf', sortable: true, label: 'Price per SF' },
					{ key: 'lease_price', sortable: true, label: 'Lease Price' },
					{ key: 'yearly_price', sortable: true, label: 'Yearly Price per SF' },
					{ key: 'property_shark_link', sortable: true, label: 'Property Shark Link' },
					{ key: 'date_listed', sortable: true, label: 'Date Listed' }
				],
				items: []
			},
			picked: false,
			DataNote: {
				noteTitle: 'About',
				noteLeaderName: '',
				items: []
			},
			allTables: {},
			NoteData: {
				popupDetailsTitle: 'Notes',
				items: []
			},
			activeNote: false,
			loadMoreActive: false,
			savedFilter: '',
			classScroll: 'prevent-scroll',
			counter: 0,
			localOrder: 'asc',
			localOrderBy: 'title',
			parentType: 'customer',
			active_filters: null,
			helperFilters: [],
			infinitScrollFlag: false,
			total: 0
		};
	},
	components: {
		SvgIcon,
		PartNote,
		BlockCustomTable,
		BlockAccordion,
		BlockPopupMatchCustomer,
		BlockPopupDetails,
		PartPopupEmail,
		SlideUpDown,
		PartNotifications,
		PartLoaderBig,
		BlockFormPopup
	},
	mixins: [onClickOutside],
	created() {
		const user = JSON.parse(localStorage.getItem('user'));
		if (localStorage.getItem('filter-customers') && this.$router.currentRoute.name === 'CustomersAdmin' && JSON.parse(localStorage.getItem('filter-customers')).user_id === user.id) {
			this.filter = JSON.parse(localStorage.getItem('filter-customers')).filter;
			this.$emit('startFiltration', this.filter);		
		}
	},
	beforeMount() {
		this.$store.dispatch('resetInititalCustomer', true);
	},
	async mounted() {
		this.preloader = true;
		const obj = {
			filter: this.filter,
			order_by: 'title',
			order: 'asc',
			id: this.$route.params.id,
			page: 1
		};
		await Promise.all([
			this.$store.dispatch('fetchStages'),
			this.$store.dispatch('matchingCustomers', obj),
			this.$store.dispatch('propertiesForMatching', obj)
		]);
		this.preloader = false;
		localStorage.setItem('tab', 'customer');
	},
	computed: {
		leadsCount() {
			return this.$store.getters.getLeadsCount;
		},
		leadsPagination() {
			return this.$store.getters.getLeadsPagination;
		},
		matches() {
			return this.$store.getters.getMatchesCustomers;
		},
		filters() {
			return this.$store.getters.getFiltersCustomers;
		},
		propertiesForMatching() {
			return this.$store.getters.getPropertiesForMatching;
		},
		customerInfo() {
			return this.$store.getters.getCustomerInfo;
		},
		allStages() {
			return this.$store.getters.getStages;
		},
		customPropertiesChangeStage() {
			return this.$store.getters.getCustomPropertiesChangeStage;
		},
		currentSelected() {
			return this.$store.getters.getCurrentSelected;
		},
		countLeadProperty() {
			return this.$store.getters.getCountLeadProperty;
		},
		getIsAllSelected() {
			return this.$store.getters.getIsAllSelected;
		},
		getTotalSelectedInStage() {
			return this.$store.getters.getTotalSelectedInStage;
		}
	},
	watch: {
		activePopup(val) {
			if (!val) {
				this.stageMany = [];
			}
		},
		getTotalSelectedInStage() {
			this.total = this.getTotalSelectedInStage.total;
		},
		countLeadProperty() {
			this.counter = this.countLeadProperty;
		},
		matches() {
			if (this.isLoadingCustomStageMany) {
				this.$refs.leadCustomers.resetSelectedCustomersNew();
			}
			this.init();
			this.counter = this.countLeadProperty;
			if (this.counter > 0) {
				this.active = true;
				this.$refs.accordionArrow.classList.add('is-open');
			} else {
				this.active = false;
				this.$refs.accordionArrow.classList.remove('is-open');
			}
		},
		propertiesForMatching() {
			this.DataMatchProperty.preloader = false;
			this.DataMatchProperty.DataMatchCustomer.items = this.propertiesForMatching.properties;
		},
		accordionCustomTable() {
			this.accordionArrow();
		}

	},
	methods: {
		async setAgainTable(obj) {
			this.infinitScrollFlag = true;
			const objForStagePaginationRequest = {
				active_filters: this.filters,
				order_by: obj.sortBy.replace('_label', '').replace('_customer', ''),
				order: obj.order,
				id: this.$route.params.id,
				stage: obj.stageId,
				page: obj.page
			};
			await this.$store.dispatch('matchingCustomersByStage', objForStagePaginationRequest);
			this.infinitScrollFlag = false;
			this.init();
		},
		async onSort(obj) {
			this.infinitScrollFlag = true;
			const objForStagePaginationRequest = {
				active_filters: this.filters,
				order_by: obj.sortBy.replace('_label', '').replace('_customer', ''),
				order: obj.order,
				id: this.$route.params.id,
				stage: obj.stageId,
				page: obj.page
			};
			await this.$store.dispatch('matchingCustomersByStage', objForStagePaginationRequest);
			this.infinitScrollFlag = false;
			this.init();
		},
		submitForm(data) {
			this.stageMany.forEach(item => {
				item.history[0].body = data.note;
			});
			this.isLoadingCustomStageMany = true;
			this.updateStage(this.stageMany, false);
			this.stageMany = [];
			this.activePopup = false;
			this.closePopupFormFirst();
			this.notificationsData.msg = 'Changed stage successfully!';
			this.notificationsData.type = 'success';
			setTimeout(() => {
				this.notificationsData.msg = '';
				this.notificationsData.type = '';
				this.isLoadingCustomStageMany = false;
			}, 2000);
			this.isAll = false;
		},
		closePopupFormFirst() {
			this.activePopup = false;
		},
		changeStageMany(obj, title, datepicker, color) {
			this.isAll = true;
			this.customPropertiesChangeStage.forEach(item => {
				const newObj = {
					customer_id: item.customer_id,
					property_id: item.property_id,
					stage_id: obj.stage_id,
					stage_name: obj.stage_name,
					stageRow: obj.stageRow,
					stageRowId: obj.stageRowId,
					history: [
						{
							stage: obj.stage_name,
							popup_date: datepicker
						}
					]
				};
				this.stageMany.push(newObj);
			});

			this.popupData.popupTitle = title;
			this.popupData.showCalendar = datepicker;
			this.activePopup = true;
		},
		toggleVisibility() {
			this.isVisible = !this.isVisible;
		},
		onClickOutside() {
			this.isVisible = false;
		},
		toggle() {
			this.active = !this.active;
			if (!this.active) {
				this.$refs.accordionArrow.classList.remove('is-open');
			} else {
				this.$refs.accordionArrow.classList.add('is-open');
			}
		},
		updateActive(newActiveValue) {
			this.active = newActiveValue;
		},
		accordionArrow() {
			if (!this.active) {
				this.$refs.accordionArrow.classList.remove('is-open');
			} else {
				this.$refs.accordionArrow.classList.add('is-open');
			}
		},
		init() {
			this.customerName = this.customerInfo.customer_name;
			this.dataTableIntro.customerEmail = this.customerInfo.primary_email || this.customerInfo.secondary_email;
			this.DataMatchProperty.DataMatchCustomer.customerEmail = this.customerInfo.primary_email || this.customerInfo.secondary_email;
			this.dataTableIntro.items = this.matches.lead;
			if (Object.keys(this.allTables).length === 0) {
				this.initTableStage();
			} else {
				this.fillTables();
			}
			this.fillAbout(this.customerInfo);
			const data = this.$store.getters.getDataCustomers;
			this.altered_building_size = data.altered_building_size;
			this.altered_lot_size = data.altered_lot_size;
		},
		fillAbout(data) {
			this.DataNote.noteLeaderName = data.customer_name;
			this.DataNote.items = [
				{ label: 'Email primary:', info: data.primary_email },
				{ label: 'Email secondary:', info: data.secondary_email },
				{ label: 'Phone primary:', info: data.primary_phone },
				{ label: 'Phone secondary:', info: data.secondary_phone },
				{ label: 'Notes:', info: data.note, classItem: 'last-item' }
			];
		},
		initTableStage() {
			this.leadsCount.forEach((item) => {
				this.allStages.forEach((stage) => {
					if (stage.id === item.stage_id && stage.title !== 'Lead') {
						this.createTableStage(stage.title, [], `${stage.title.replace('st_', '').replaceAll('_', ' ')}`, item.count, stage.color, stage.id);
					}
				});
			});
		},
		fillTables() {
			this.leadsCount.forEach((item) => {
				this.allStages.forEach((stage) => {
					if (stage.id === item.stage_id && stage.title !== 'Lead') {
						const revertName = `st_${stage.title.replaceAll(' ', '_')}`;
						const stageItems = this.matches.stages[revertName] ?? [];
						this.createTableStage(stage.title, stageItems, stage.title, item.count, stage.color, stage.id);
					}
				});
			});

			this.allTablesCount = this.leadsCount.map((item) => {
				const newStage = {};
				this.allStages.forEach((stage) => {
					if (stage.id === item.stage_id) {
						newStage.title = stage.title;
						newStage.count = item.count;
					}
				});
				return newStage;
			});

			this.$forceUpdate();
		},
		createTableStage(flag, stage, stageName, count, color, stageId) {
			this.allTables[flag] = {
				buttonName: stageName,
				buttonNameColor: color,
				stageId: stageId,
				userNum: count > 1 ? count + ' Properties' : count + ' Property',
				total: count,
				sort: 'title',
				DataAccordionTable: {
					stageTable: true,
					stickyHeader: true,
					noCollapse: false,
					// noLocalSorting: false,
					tableClass: 'text-nowrap',
					fields: [
						{ key: 'title', label: 'Property', flag: 'match', sortable: true, stickyColumn: true, variant: 'property thead-lg' },
						{ key: 'stage_icon', label: 'Stage', sortable: false, stickyColumn: true, variant: 'stage' },
						// { key: 'source', label: 'Source', sortable: true, stickyColumn: true, variant: 'source' },
						{ key: 'area_label', label: 'Area', sortable: true, stickyColumn: true, variant: 'area' },
						{ key: 'property_type_label', label: 'Property Type', sortable: true, stickyColumn: true, variant: 'property-type' },
						{ key: 'regular_price', label: 'Price', sortable: true, stickyColumn: true, variant: 'price' },
						{ key: 'price_buildable_sf', label: 'Price per Buildable SF', sortable: true, stickyColumn: true, variant: 'price-buildable-sf' },
						{ key: 'price_psf', label: 'Price per SF', sortable: true, stickyColumn: true, variant: 'price-psf' },
						{ key: 'lease_price', label: 'Lease Price', sortable: true, stickyColumn: true, variant: 'lease-price' },
						{ key: 'yearly_price', label: 'Yearly Price per SF', sortable: true, stickyColumn: true, variant: 'yearly-price' },
						{ key: 'property_shark_link', label: 'Property Shark Link', sortable: false, stickyColumn: true, variant: 'property-shark-link' },
						{ key: 'date_listed', label: 'Date Listed', sortable: true, stickyColumn: false, variant: 'date-icon' },
						{ key: 'delete-stage', label: '', sortable: false, stickyColumn: true, variant: 'delete' }
					],
					items: stage
				}
			};
		},

		// Delete table when its empty
		deleteTableStage(flag) {
			delete this.allTables[flag];
		},
		// Update stages from Lead to any other stage and remove stage from Lead table
		async updateStage(obj, flag) {
			const adminOrAgent = this.leadsPagination;
			this.infinitScrollFlag = true;
			if (this.helperFilters.length && flag) {
				obj.active_filters = this.active_filters;
			}

			await this.$store.dispatch('assignCustomerToStageNew', { 
				req: (flag) ? [obj] : obj, 
				stages: this.allStages,
				filter: this.filter,
				id: this.$route.params.id,
				page: 1,
				order_by: adminOrAgent.sort_by.replace('_label', '').replace('_customer', ''),
				order: adminOrAgent.order
			}).then((res) => {
				if (res.req[0].stage_name === 'Lead') {
					this.$refs.leadCustomers && this.$refs.leadCustomers.scrollTo && this.$refs.tableCustom.scrollTo({ top: 0 });
				}
			});
			this.allTables = {};
			setTimeout(() => {
				this.init();
				this.$forceUpdate();
			}, 100);
			this.$store.dispatch('resetCustomPropertiesChangeStage');
			this.infinitScrollFlag = false;
			// this.$root.$emit('sortData', false);
		},

		// Update stages from not Lead to any other stage
		noLeadUpdate(obj) {
			this.updateStage(obj, true);
		},

		// Move property to dismiss stage
		dismissStage(obj) {
			this.$store.dispatch('assignPropertyToStage', obj);
		},
		showNote() {
			this.$refs.breadcrumbs.classList.add('show-note');
		},
		hideNote() {
			this.$refs.breadcrumbs.classList.remove('show-note');
		},
		popupToggle() {
			this.showPopup = true;
			this.$refs.propertiesHeader.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.classList.add(this.classScroll);
		},
		closePopupCustomer() {
			this.showPopup = false;
			this.$refs.propertiesHeader.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.classList.remove(this.classScroll);
		},
		goInDashboard() {
			return this.$route.fullPath.includes('admin');
		},
		disableAllPills(group) {
			const flag = 'group';
			let groupStatus = true;
			group.labels.forEach(pill => {
				if (!pill.show) {
					groupStatus = false;
				}
			});
			const keys = [];
			const pills = [];
			group.labels.forEach(pill => {
				keys.push(group.key);
				pills.push(pill);
			});	
			// this.helperFilters = [];
			this.deactivateFilterPill(keys, pills, flag, groupStatus);
		},
		async deactivateFilterPill(key, item, flag, status = true) {
			this.localOrderBy = this.localOrderBy.replace('_label', '').replace('_customer', '');
			this.preloader = true;
			this.dataTableIntro.items = [];
			this.preventGetPage = true;
			this.$store.dispatch('setLeadsPaginationAction', { data: { current_page: 1 }, paginationInfo: { sort_by: this.localOrderBy ?? 'title', order: this.localOrder ?? 'asc' } });
			for (const refKey in this.$refs.stageTableRefs) {
				if (Object.prototype.hasOwnProperty.call(this.$refs.stageTableRefs, refKey)) {
					this.$refs.stageTableRefs[refKey].openAccordion('st_Lead');
				}
			}

			if (Array.isArray(key)) {
				key.forEach(async (k, index) => {
					const obj = {
						key: k,
						item: item[index]
					};
					if (flag) {
						obj.flag = flag;
					}
					if (obj.flag === 'group') {
						obj.status = status;
						await this.$store.dispatch('enablePillsCustomers', obj);
					} else {
						await this.$store.dispatch('togglePillsCustomers', obj);
					}
		
					if (!obj.item.show) {
						this.helperFilters.push(obj);
					} else {
						let i;
						this.helperFilters.forEach(el => {
							i = this.helperFilters.findIndex(el => el.key === obj.k && el.item.value === obj.item.value);
						});
						this.helperFilters.splice(i, 1);
					}
				});
			} else {
				const obj = {
					key: key,
					item: item
				};
				if (flag) {
					obj.flag = flag;
				}
				if (obj.flag === 'group') {
					obj.status = status;
					await this.$store.dispatch('enablePillsCustomers', obj);
				} else {
					await this.$store.dispatch('togglePillsCustomers', obj);
				}
	
				if (!obj.item.show) {
					this.helperFilters.push(obj);
				} else {
					let index;
					this.helperFilters.forEach(el => {
						index = this.helperFilters.findIndex(el => el.key === obj.key && el.item.value === obj.item.value);
					});
					this.helperFilters.splice(index, 1);
				}
			}
			// If some filter pill is turn off send active filters to BE
			if (this.helperFilters.length) {
				this.active_filters = this.filters;
				await this.$store.dispatch('mutationFiltersCustomers', { id: this.$route.params.id, active_filters: this.active_filters, page: 1, order_by: this.localOrderBy ?? 'title', order: this.localOrder ?? 'asc' });
				this.preloader = false;
			} else {
				this.active_filters = this.filters;
				await this.$store.dispatch('mutationFiltersCustomers', { id: this.$route.params.id, active_filters: this.active_filters, page: 1, order_by: this.localOrderBy ?? 'title', order: this.localOrder ?? 'asc' });
				this.preloader = false;
			}
			this.$root.$emit('sortData', false);	
		},
		showPopupNote(pivot) {
			this.$store.dispatch('stageHistory', pivot).then(res => {
				this.NoteData.items = res.data.history;
				this.NoteData.pivot = pivot;
				this.activeNote = true;
				this.$refs.propertiesHeader.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.classList.add(this.classScroll);
			});
		},
		closePopupForm() {
			this.activeNote = false;
			this.$refs.propertiesHeader.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.classList.remove(this.classScroll);
		},
		startFiltration(data) {
			this.filtrationInProgress = true;
			this.DataMatchProperty.preloader = true;
			const obj = {
				filter: {
					search: data
				},
				id: this.$route.params.id,
				page: 1
			};
			this.savedFilter = data;
			this.$store.dispatch('propertiesForMatching', obj).then(res => {
				this.DataMatchProperty.DataMatchCustomer.items = res.data.properties;
				this.DataMatchProperty.preloader = false;
				this.$root.$emit('sortData');
			});
		},
		// Load more properties if prev loadMore finish and if we have next page
		async loadMore() {
			const adminOrAgent = this.leadsPagination;
			let nextPage = adminOrAgent.current_page++;
			(adminOrAgent.current_page === 0)
				? nextPage = 1
				: nextPage = adminOrAgent.current_page++;
			if (this.infinitScrollFlag || nextPage > adminOrAgent.last_page) {
				this.preventGetPage = false;
				return false;
			}

			this.infinitScrollFlag = true;
			await this.$store.dispatch('matchingCustomers', { 
				active_filters: this.filters,
				id: this.$route.params.id,
				page: nextPage,
				order_by: this.localOrderBy.replace('_label', '').replace('_customer', ''),
				order: this.localOrder
			});

			this.infinitScrollFlag = false;
			this.init();
		},
		async onSortLead(obj) {
			this.infinitScrollFlag = true;
			const objForStagePaginationRequest = {
				active_filters: this.filters,
				order_by: obj?.sortBy?.replace('_label', '').replace('_customer', '') ?? 'title',
				order: obj.order,
				id: this.$route.params.id,
				page: 1
			};
			await this.$store.dispatch('matchingCustomers', objForStagePaginationRequest);
			this.infinitScrollFlag = false;
			this.init();
		},
		formatDollars(field) {
			return formatNumber(field);
		},
		sortData() {
			this.$emit('sortData');
		},
		// sortData(item) {
		// 	this.DataMatchProperty.preloader = true;
		// 	const obj = {
		// 		order_by: item,
		// 		order: this.SortOrder(item),
		// 		id: this.$route.params.id,
		// 		page: 1
		// 	};
		// 	this.DataMatchProperty.DataMatchCustomer.fields.forEach(el => {
		// 		if (el.key === item) {
		// 			el.sortOrder = obj.order;
		// 		} else {
		// 			delete el.sortOrder;
		// 		}
		// 	});
		// 	this.localOrderBy = item;
		// 	// this.$store.dispatch('propertiesForMatching', obj);
		// },
		sortLeads(item) {
			const obj = {
				order_by: item,
				order: this.SortOrder(),
				id: this.$route.params.id,
				page: 1,
				active_filters: this.active_filters
			};
			this.dataTableIntro.fields.forEach(el => {
				if (el.key === item) {
					el.sortOrder = obj.order;
				} else {
					delete el.sortOrder;
				}
			});

			this.localOrderBy = item.sortBy;
			// this.$store.dispatch('sortPropertiesLeads', obj);
		},
		SortOrder() {
			if (this.localOrder === 'asc') {
				this.localOrder = 'desc';
			} else {
				this.localOrder = 'asc';
			}
			return this.localOrder;
		},
		async sendEmailPopup(pivot) {
			// single customer email sending logic goes here
			this.emailPopup = true;
			// Pass pivot data from row in custom table
			this.DataPartPopupEmail.pivot = pivot;
			this.DataMatchProperty.pivot = pivot;
			this.selectedPropertyPdfLink = await this.$store.dispatch('fetchUnpersonalizedPdf', pivot.property_id);
			// Pass filters
			if (!pivot.manualFlag) {
				this.DataPartPopupEmail.active_filters = this.active_filters;
			}
		},
		afterSendEmail() {
			this.initTableStage();
			this.$forceUpdate();
			this.shouldEmptyCheckedRows = true;
		},
		closePopupEmail(notification) {
			if (notification) {
				this.notification(notification);
			}
			this.$refs.propertiesHeader.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.classList.remove(this.classScroll);
			this.preloader = false;
			this.emailPopup = false;
			this.DataPartPopupEmail.active_filters = null;
			this.closePopupCustomer();
		},
		notification(response) {
			this.notificationsData.msg = response.message;
			this.notificationsData.type = response.status === 200 ? 'success' : 'danger';

			setTimeout(() => {
				this.notificationsData.msg = '';
				this.notificationsData.type = '';
			}, 2000);
		},
		sendingEmail() {
			this.$refs.propertiesHeader.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.classList.add(this.classScroll);
			this.preloader = false;
			this.$refs.emailPopup.uploading = true;
		},
		archiveCustomer() {
			this.$store.dispatch('archiveCustomer', this.$route.params.id).then(() => {
				if (this.goInDashboard()) {
					this.$router.push({ name: 'CustomersAdmin' });
				} else {
					this.$router.push({ name: 'CustomersAgent' });
				}
			});
		},
		goBack() {
			this.$router.go(-1);
			setTimeout(() => {
				location.reload();
			}, 500);
		}
	}
};
</script>
<style lang="scss" scoped>
.leader-header {
	display: flex;
	flex-direction: column;
}

.page-leader__header {
	border-bottom: 1px solid $grey-light;
	margin-bottom: 20px;

	@include mq(1440px) {
		padding: 20px 0;
	}

	@include mq($lg) {
		padding: 0 0 20px;
		margin-bottom: 20px;
	}
}

/*--------------------------------------------------------------
## Custom table accordion-custom-table
--------------------------------------------------------------*/
.accordion-custom-table__button {
	display: flex;
	background-color: $white-lilac; 
	padding: 11px 43px 11px 13px;
	margin-top: 25px;
	position: relative;
	align-items: center;
	text-decoration: none;
	transition: $dur $ease;

	@include mq($lg) {
		flex-wrap: wrap;
	}

	@include mq(350px) {
		padding: 11px 43px 11px 7px;
		margin-top: 20px;
	}

	@include hover  {
		background-color: $athens-gray;
	}
}

.accordion-custom-table__item {
	&.is-open {
		.accordion-custom-table__button-arrow {
			transform: rotateX(-180deg);
		}
	}
}
.accordion-custom-table__button-name {
	padding: 2px 7px;
	font-family: $font-main;
	font-weight: 500;
	font-size: 16px;
	line-height: 24px;
	color: $white;
	border-radius: 8px;
	margin-right: 13px;
	background-color: rgb(255, 152, 0);

	@include mq($lg) {
		font-size: 14px;
	}

	@include mq(350px) {
		font-size: 13px;
		margin-right: 5px;
	}
}

.accordion-custom-table__button-num {
	font-family: $font-main;
	font-size: 14px;
	line-height: 20px;
	color: $shark;
	opacity: 0.5;

	@include mq($lg) {
		font-size: 12px;
	}

	@include mq(350px) {
		font-size: 11px;
	}
}

.accordion-custom-table__button-icon {
	position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
}

.accordion-custom-table__button-arrow {
	font-size: 27px;
    display: block;
	transition: $dur $ease;
	color: $fiord;
}

.accordion-custom-table__list-button {
	margin-bottom: 0;
	cursor: pointer;
}

.page-leader__header-matching-properties {
	display: flex;
	flex-wrap: wrap;
	position: relative;
	margin-bottom: 14px;
	justify-content: space-between;

	@include mq($sm) {
		flex-direction: column;

	}
}

.leader-header__button-arhive {
	@include mq(419px) {
		margin-top: 15px;
	}
}

.leader-header__breadcrumb {
	@include mq(830px) {
		align-self: baseline;
	}
}

.leader-header__filters {
	padding-left: 0;
}

.leader-header__critical-note {
	padding: 0 0 10px;
	span {
		font-family: $font-main;
		font-size: 14px;
		line-height: 1.2;
		color: $fiord;
		text-align: left;
		display: block;
	}
}

.breadcrumbs__link {
	cursor: pointer;
}

.section-title--matching-properties {
	display: flex;
	align-items: center;
}

.select-stage {
	display: flex;
	align-items: center;

	@include mq($sm) {
		margin-left: auto;
	}

	label {
		color: $fiord;
		font-family: $font-main;
		font-size: 14px;
		line-height: 20px;
		font-weight: 400;
		margin-right: 8px;
	}

	&.select-stage--disabled {
		opacity: 0.5;
		pointer-events: none;
	}
}

.select-stage__select-wrap {
	position: relative;
	cursor: pointer;

	.dropdown_stages {
		right: 0;
		left: auto;
		top: 102%;
		position: absolute !important;

		@include mq(640px) {
			transform: none;
		}
	}

	.color-picker__item {
		&:last-of-type {
			margin-bottom: 0;
		}
	}

	.dropdown__link {
		padding-left: 0;
	}

	.dropdown__holder {
		min-width: 66px;

		span,
		&::before,
		&::after {
			transition: $dur $ease;
		}

		&.dropdown__holder--first-selected {
			background-color: rgb(255, 152, 0);
		}
	}
}

.select-stage__select {
	border: 1px solid $grey-light;
	padding: 10px 16px 10px 12px;
	border-radius: 8px;
	position: relative;
	display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 170px;

	&.active {
		.select-stage__select-icon {
			/deep/ {
				svg {
					transform: rotate(180deg);
				}
			}
		}
	}
}

.select-stage__select-icon {
	
	/deep/ {
		svg {
			height: 10px;
			width: 10px;
			color: $fiord;
		}
	}
}

.header-matching-properties__selected-items {
	display: block;
    width: 100%;
    margin-left: auto;
    text-align: right;
    margin-top: 10px;
	font-family: $font-main;
    font-size: 14px;
	color: $fiord;
	opacity: 0;
	transition: $dur $ease;

	@include mq($sm) {
		font-size: 12px;
	}

	&.show {
		opacity: 1;
	}
}

.block-match-customer__popup {
	/deep/
	.custom-table__table {
		th {
			.checkbox-wrap {
				display: none;
			}
		}
	}

	/deep/
	.property-img-cell-checkbox-wrap {
		display: none;
	}

	/deep/
	.table__img {
		width: 100%;
		flex: 0 0 auto;
		height: auto;
	}

	/deep/
	.custom-table__td {
		&:first-of-type {
			max-width: 325px;
			min-width: 325px !important;//sass-lint:disable-line no-important
			
			@include mq($md) {
				max-width: 250px;
				min-width: 250px !important;//sass-lint:disable-line no-important
			}

			@include mq($sm) {
				max-width: 150px;
				min-width: 150px !important;//sass-lint:disable-line no-important
			}

			.property-img-cell-wrap-text {
				display: flex;
				flex-direction: column;
			}
		}

		.img-link {
			width: 150px;
			min-width: 150px;
			max-width: 150px;

			@include mq($sm) {
				min-height: auto;
				max-height: 80px;
				max-width: 50px;
				min-width: 50px;
				width: 50px;
				pointer-events: all;
			}

			.table__img {
				max-width: 100%;
			}
		}	

		.property-img-cell-wrap-text {
			.img-link {
				max-height: auto;
				height: auto;
				width: auto;
				min-width: auto;
				max-width: none;
			}
		}	
	}

	/deep/
	.property-img-cell-wrap {
		flex-direction: row;
	}
}
</style>
